import { SearchTab } from "@/components/search/SearchTab";
import "./SearchTabs.scss";

interface ISearchTabs {
  onClick: (tab: searchTabsEnum) => void;
  activeTab: string;
}

export enum searchTabsEnum {
  ALL = "all",
  TAGS = "tags",
  NICHES = "niches",
  CREATORS = "creators",
}

export const SearchTabs = ({ onClick, activeTab }: ISearchTabs) => (
  <div className="searchTabs">
    {Object.values(searchTabsEnum).map((tab) =>
      <SearchTab
        key={tab}
        onClick={onClick}
        tabName={tab}
        isActive={activeTab === tab}
      />
    )}
  </div>
);
